import {Component, EventEmitter, Output} from '@angular/core';
import {
    getDownloadURL,
    percentage,
    ref,
    Storage,
    uploadBytesResumable,
    UploadTask,
    UploadTaskSnapshot
} from '@angular/fire/storage';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {DropZoneDirective} from '../../directives/drop-zone.directive';
import {MatButton} from '@angular/material/button';
import {AsyncPipe, DecimalPipe} from '@angular/common';



@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    imports: [
        DropZoneDirective,
        DropZoneDirective,
        MatButton,
        MatButton,
        MatButton,
        AsyncPipe,
        DecimalPipe
    ],
    styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent {

    @Output() public url = new EventEmitter<string>();
    @Output() public uploadProcess = new EventEmitter<boolean>();

    // Main task
    task: UploadTask;

    // Progress monitoring
    percentage: Observable<number>;

    snapshot: Observable<UploadTaskSnapshot>;

    // Download URL
    downloadURL: string;

    // State for dropzone CSS toggling
    isHovering: boolean;

    constructor(private storage: Storage) {
    }


    toggleHover(event: boolean) {
        this.isHovering = event;
    }

    startUpload(event: Event | FileList) {
        let file: File;
        if (event instanceof FileList) {
            file = event.item(0);
        } else {
            file = (event.target as HTMLInputElement).files[0];
        }

        // Client-side validation example
        if (file.type !== 'application/pdf') {
            console.error('unsupported file type :( ' + file.type + ')');
            return;
        }

        // The storage path
        const path = `invoices/${new Date().getTime()}_${file.name}`;
        const storageRef = ref(this.storage, path);

        // Totally optional metadata
        const customMetadata = {app: 'ExtraVega'};

        // The main task
        this.task = uploadBytesResumable(storageRef, file, {customMetadata});

        // Progress monitoring
        this.percentage = percentage(this.task).pipe(map(s => s.progress));
        this.snapshot = new Observable<UploadTaskSnapshot>(subscriber => {
            const unsubscribe = this.task.on('state_changed',
                snapshot => subscriber.next(snapshot),
                error => subscriber.error(error),
                () => {
                    getDownloadURL(storageRef).then(downloadURL => {
                        this.downloadURL = downloadURL;
                        this.url.emit(this.downloadURL);
                        console.log(downloadURL);
                        subscriber.complete();
                    });
                }
            );
            return () => unsubscribe();
        });
    }

    // Determines if the upload task is active
    isActive(snapshot) {
        const progress = (snapshot.state === 'running' && snapshot.bytesTransferred < snapshot.totalBytes);
        this.uploadProcess.emit(progress);
        return progress;
    }

}
